<template>
  <div class="Upload-box Upload1 target-box" v-if="imageOpen">
    <div class="close" @click="closeDialog">
      X
      <!-- <img src="https://www.yasubit.com/template/pc/skin/images/icon43.png" alt="" /> -->
    </div>
    <!-- <div class="zoomx z1" @click="minimizeDialog">-</div> -->
    <div class="box" id="f_uplo1">
      <div class="list">
        <ul id="demoList">
          <li class="title">
            <div class="t1">{{ $t('message.fileName') }}</div>
            <div class="t2">{{ $t('message.originalFileSize') }}</div>
            <div class="t3">{{ $t('message.status') }}</div>
            <div class="t4">{{ $t('message.compressedFileSize') }}</div>
            <div class="t6">{{ $t('message.fileSizeReduced') }}</div>
            <div class="t5">{{ $t('message.action') }}</div>
          </li>
          <li v-for="(item, index) in imageDataList" :key="index">
            <div class="t1">
              <img src="https://www.yasubit.com/template/pc/skin/images/icon10.png" alt="" /><span>{{ item.fileName
                }}<span></span></span>
            </div>
            <div class="t2">
              {{ (item.size / (1024 * 1024)).toFixed(2) + " MB" }}
            </div>
            <div class="t3">
              <div class="layui-progress" lay-filter="progress-demo-1705310614597-0">
                <div class="layui-progress-bar" :lay-percent="item.progress + '%'"
                  :style="{ width: item.progress + '%' }"></div>
              </div>
            </div>
            <div class="t4">
              <span v-if="item.compSize && item.compressionStatus === 'DONE'">{{ (item.compSize / (1024 *
    1024)).toFixed(2) + " MB" }}</span>
              <span v-else-if="item.compressionStatus === 'MERGING'">{{ $t('message.merging') }}</span>
              <span v-else> {{ " " }}</span>
            </div>
            <div class="t6" style="color: rgb(95, 184, 120)">
              <span v-if="item.compSize && item.origSize && item.compressionStatus === 'DONE'">{{ ((1 - item.compSize /
    item.origSize) * 100).toFixed(2) + "%" }}</span>
              <span v-else> {{ " " }}</span>
            </div>
            <div class="t5">
              <span class="s1" @click="deleteImage(index)">{{ $t('message.delete') }}</span>
              <span v-if="item.isUploading" class="s3" @click="togglePause(index)">
                {{ item.isPaused ? $t('message.resume') : $t('message.pause') }}
              </span>
              <span v-if="item.compressionStatus === 'DONE'" download="" class="s2" style="cursor: pointer"
                @click="downloadImage(index)">{{ $t('message.download') }}</span>
              <span v-else>{{ " " }}</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="ckbox">
        <div class="cc1">
          <div class="check" v-if="status !== 2">
            <span><img src="https://www.yasubit.com/template/pc/skin/images/icon12.png" alt="" /></span>
            {{ $t('message.clickOrDragToAddImage') }}
            <el-upload :class="['c4', status === 2 ? 'custom-upload' : 'custom-upload']" drag action="" ref="uploadRef"
              multiple accept=".jpg,.jpeg,.png,.webp" :show-file-list="false" :auto-upload="false"
              :on-change="handleFileChange" :on-drop="handleMultipleFiles">
            </el-upload>
          </div>
          <div class="check" v-else>
            <span><img src="https://www.yasubit.com/template/pc/skin/images/icon12.png" alt="" /></span>
            {{ $t('message.continueToAddImage') }}
            <el-upload :class="['c4', status === 2 ? 'custom-upload' : 'custom-upload']" drag action="" ref="uploadRef"
              multiple accept=".jpg,.jpeg,.png,.webp" :show-file-list="false" :auto-upload="false"
              :on-change="handleFileChange" :on-drop="handleMultipleFiles">
            </el-upload>
          </div>
        </div>
      </div>
      <div class="ckbox2">
        <div class="left">
          共上传<span class="shu1">{{ imageDataList.length }}</span>图片
        </div>
        <div class="right">
          <!-- 压缩选项：
                    <input type="radio" name="radio" id="ck0" value="0" checked><label for="ck0" class="radio-label"
                        value="1">缩小优先(默认)</label>
                    <input type="radio" name="radio" id="ck1" value="1"><label for="ck1" class="radio-label"
                        value="1">正常质量</label>
                    <input type="radio" name="radio" id="ck2" value="2"><label for="ck2" class="radio-label"
                        value="2">清晰优先</label> -->

          <div v-if="status === 0" class="start disable" id="img_tijiao">
            {{ $t('message.startCompress') }}
          </div>
          <div v-if="status === 1" class="start uploading" id="img_tijiao">
            {{ $t('message.uploading') }}
          </div>
          <div v-if="status === 2 && compressionStatus === 'COMPRESSING'" class="start compressing" id="img_tijiao">
            {{ $t('message.compressing') }}
          </div>
          <div v-if="status === 2 && compressionStatus === 'DONE'" @click="downloadAll" class="start"
            style="background-color: #5fb878 !important" id="img_downloadAll">
            {{ $t('message.downloadAll')}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { saveAs } from "file-saver";
import axios from "axios";
import { ImprovedChunkUploader } from '@/utils/improved-chunk-uploader';
import { SimpleDownloader } from '@/utils/simple-downloader';
import JSZip from 'jszip';
import { getUploadConfig, getUserLimits, isSupportedFile } from '@/config/upload-config';

export default {
  props: {
    imageOpen: Boolean
  },
  data() {
    return {
      imageDataList: [],
      status: 0,
      chunkUploader: null,
      downloader: null,
      userId: null,
      compressionStatus: '',
      isGuest: true,

      // --- 核心状态 ---
      uploadQueue: [],
      isUploadingFromQueue: false,
      fileBuffer: [], // 文件缓冲区，用于收集瞬时添加的所有文件
      addFilesTimer: null, // 用于批处理的计时器
    };
  },
  async mounted() {
    const userInfo = await this.getUserInfo();
    const sliceUrl = '/yasubit/upload/slice';
    const statusUrl = '/yasubit/upload/task/status';

    if (userInfo) {
      this.userId = userInfo.usersId;
      this.isGuest = false;
    } else {
      this.userId = 'guest-' + Math.random().toString(36).substring(2, 15);
      this.isGuest = true;
    }
    const config = getUploadConfig('image');
    this.chunkUploader = new ImprovedChunkUploader({
      sliceUrl, statusUrl, userId: this.userId,
      chunkSize: config.chunkSize, maxConcurrent: config.maxConcurrent,
      retryDelay: config.retryDelay, maxRetries: config.maxRetries, pollInterval: config.pollInterval
    });
    this.downloader = new SimpleDownloader({ maxRetries: 3, retryDelay: 1000, timeout: 30000 });
  },
  methods: {
    // --- UI and Helper Methods ---
    closeDialog() {
      this.imageDataList = []; this.uploadQueue = []; this.fileBuffer = [];
      this.isUploadingFromQueue = false; this.status = 0;
      clearTimeout(this.addFilesTimer);
      this.$emit('close');
    },
    minimizeDialog() {
      this.$emit('minimize');
    },
    async getUserInfo() {
      const token = localStorage.getItem("loginToken");
      if (!token) return null;
      try {
        const response = await this.$http.get("yasubit/users/info", { headers: { Authorization: `Bearer ${token}` } });
        return response.data.code === 200 ? response.data.data : null;
      } catch (error) {
        return null;
      }
    },
    getFullImageUrl(relativePath) {
      return this.$fileBaseURL + relativePath;
    },

    // --- Core Upload Flow (The Correct, Debounced Logic) ---

    handleFileChange(file) {
      if (file.status !== 'ready') return;
      if (!isSupportedFile(file.raw, 'image')) {
        this.$message.error(this.$t('message.unsupportedImageFormat') || '不支持的图片格式');
        return;
      }
      this.fileBuffer.push(file.raw);
      this.scheduleBufferProcessing();
    },
    handleMultipleFiles(files) {
      const validFiles = files.filter(f => isSupportedFile(f, 'image'));
      const invalidFiles = files.filter(f => !isSupportedFile(f, 'image'));

      if (invalidFiles.length > 0) {
        this.$message.error(this.$t('message.unsupportedImageFormat') || '存在不支持的文件格式');
      }
      // on-drop provides an array of File objects directly
      this.fileBuffer.push(...files);
      this.scheduleBufferProcessing();
    },
    scheduleBufferProcessing() {
      clearTimeout(this.addFilesTimer);
      this.addFilesTimer = setTimeout(() => {
        this.processBufferedFiles();
      }, 50); // 50ms delay to batch all concurrent file additions
    },
    processBufferedFiles() {
      const filesToProcess = [...this.fileBuffer];
      this.fileBuffer = []; // Clear buffer immediately
      if (filesToProcess.length === 0) return;

      const limits = getUserLimits('image', this.isGuest);
      if (limits) {
        const currentTotal = this.imageDataList.length + this.uploadQueue.length;
        if (currentTotal + filesToProcess.length > limits.maxFiles) {
          this.$message.error(this.$t('message.guestMaxUpload', { count: limits.maxFiles }));
          return;
        }
      }

      const newFiles = filesToProcess.filter(rawFile => {
        if (limits && rawFile.size > limits.maxFileSize) {
          const sizeMB = Math.round(limits.maxFileSize / (1024 * 1024));
          this.$message.error(this.$t('message.guestImageSizeLimit', { size: sizeMB, name: rawFile.name }));
          return false;
        }
        if (!isSupportedFile(rawFile, 'image')) {
          this.$message.error(this.$t('message.unsupportedImageFormat'));
          return false;
        }
        const isAlreadyPresent = this.imageDataList.some(item => item.fileName === rawFile.name) || this.uploadQueue.some(item => item.name === rawFile.name);
        if (isAlreadyPresent) {
          this.$message.error(this.$t('message.imageAlreadyExists', { name: rawFile.name }));
          return false;
        }
        return true;
      });

      if (newFiles.length === 0) return;

      newFiles.forEach(rawFile => {
        this.uploadQueue.push(rawFile);
        this.imageDataList.push({
          fileName: rawFile.name, size: rawFile.size, progress: 0,
          isUploading: false, isPaused: false, uploadId: null, compressionStatus: 'WAITING'
        });
      });

      if (this.imageDataList.length > 0) this.status = 1;
      this.processQueue();
    },
    async processQueue() {
      if (this.isUploadingFromQueue || this.uploadQueue.length === 0) return;
      this.isUploadingFromQueue = true;
      const file = this.uploadQueue.shift();
      const fileIndex = this.imageDataList.findIndex(item => item.fileName === file.name);

      if (fileIndex === -1) {
        this.isUploadingFromQueue = false;
        this.processQueue();
        return;
      }

      this.$set(this.imageDataList[fileIndex], 'isUploading', true);
      this.$set(this.imageDataList[fileIndex], 'compressionStatus', 'UPLOADING');

      try {
        const uploadId = await this.chunkUploader.createUploadTask(file.name, file.size);
        this.$set(this.imageDataList[fileIndex], 'uploadId', uploadId);
        await this.chunkUploader.upload(file,
          (percent) => { if (this.imageDataList[fileIndex]) this.$set(this.imageDataList[fileIndex], 'progress', percent); },
          uploadId,
          (status, data) => {
            if (!this.imageDataList[fileIndex]) return;
            this.compressionStatus = status;
            if (status === 'COMPRESSING') this.status = 2;
            if (data) Object.assign(this.imageDataList[fileIndex], { origSize: data.origSize, compSize: data.compSize, compUrl: data.compUrl, origUrl: data.origUrl, compressionStatus: status });
            if (status === 'FAILED') {
              this.$set(this.imageDataList[fileIndex], 'error', true);
              this.$message.error(this.$t('message.compressionFailed', { name: file.name }));
            }
          }
        );
        if (this.imageDataList[fileIndex]) {
          this.$set(this.imageDataList[fileIndex], 'isUploading', false);
          this.$set(this.imageDataList[fileIndex], 'finish', true);
        }
      } catch (error) {
        if (this.imageDataList[fileIndex]) {
          this.$set(this.imageDataList[fileIndex], 'isUploading', false);
          this.$set(this.imageDataList[fileIndex], 'error', true);
          this.$message.error(this.$t('message.uploadFailed', { name: file.name, msg: error.message || this.$t('message.unknownError') }));
        }
      } finally {
        this.isUploadingFromQueue = false;
        this.checkAllUploadsFinished();
        this.processQueue();
      }
    },

    // --- Action Handlers and Status Check ---
    async deleteImage(index) {
      const itemToDelete = this.imageDataList[index];
      if (!itemToDelete) return;
      const queueIndex = this.uploadQueue.findIndex(file => file.name === itemToDelete.fileName);
      if (queueIndex !== -1) this.uploadQueue.splice(queueIndex, 1);
      if (itemToDelete.isUploading && itemToDelete.uploadId) {
        await this.chunkUploader.cancelUpload(itemToDelete.uploadId);
        this.isUploadingFromQueue = false;
        setTimeout(() => this.processQueue(), 100);
      }
      this.imageDataList.splice(index, 1);
    },
    async togglePause(index) {
      const item = this.imageDataList[index];
      if (!item || !item.isUploading) return;
      try {
        if (item.isPaused) {
          await this.chunkUploader.resumeUpload(item.uploadId);
          this.$set(item, 'isPaused', false);
        } else {
          await this.chunkUploader.pauseUpload(item.uploadId);
          this.$set(item, 'isPaused', true);
        }
      } catch (error) {
        this.$message.error(item.isPaused ? this.$t('message.resumeUploadFailed') : this.$t('message.pauseUploadFailed'));
      }
    },

    // in ImageCompress.vue methods

    async downloadImage(index) {
      const row = this.imageDataList[index];
      if (!row || !row.compUrl) {
        this.$message.error(this.$t('message.downloadFailed'));
        return;
      }

      try {
        const link = document.createElement("a");
        link.href = this.$fileBaseURL + row.compUrl;  // 拼接完整地址
        link.download = row.fileName || "download.png"; // 指定下载文件名
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Image download failed:", error);
        this.$message.error(this.$t('message.downloadFailed'));
      }
    }
    ,
    async downloadAll() {
      try {
        const filePaths = this.imageDataList
          .filter(row => row.compUrl)
          .map(row => row.compUrl);

        if (filePaths.length === 0) {
          this.$message.warning(this.$t('message.noDownloadableFiles'));
          return;
        }
        this.$message.info(this.$t('message.startDownloading'));
        const response = await axios.post('/yasubit/download/zip', filePaths, {
          responseType: 'blob',
          timeout: 0
        });

        const blob = new Blob([response.data], { type: 'application/zip' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Yasubit-${new Date().toISOString().replace(/[:.-]/g, "").substring(0, 15)}.zip`;
        link.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.$message.error(this.$t('message.createZipFailed'));
      }
    }
    ,
    checkAllUploadsFinished() {
      if (this.uploadQueue.length === 0 && !this.isUploadingFromQueue && this.imageDataList.length > 0) {
        const allDone = this.imageDataList.every(item => item.finish || item.error);
        if (allDone) {
          this.status = 2;
        }
      }
    },
  },
  watch: {
    imageDataList: {
      handler(newList) {
        if (newList.length === 0) {
          this.status = 0;
          this.uploadQueue = [];
          this.isUploadingFromQueue = false;
        }
      },
      deep: true
    }
  }
};
</script>

<style scoped>
/* Add or move relevant styles from Home.vue here */
/* Example styles - adjust based on your actual styles */
.Upload-box {
  /* styles */
}

.Upload-box .box {
  /* styles */
}

.Upload-box .box .list li .t1 span {
  /* styles */
}

.cc1 {
  /* styles */
}

::v-deep .custom-upload .el-upload-dragger {
  /* styles */
}

::v-deep .none_upload .el-upload-dragger {
  /* styles */
}

.disable {
  /* styles */
}
</style>